/**
 * Data Aggregator API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeviceMetaInformationDto { 
    idDevice?: number;
    firstReception?: string;
    lastReception?: string;
    lastReceptionEventType?: DeviceMetaInformationDto.LastReceptionEventTypeEnum;
    country?: string;
    activityCount?: number;
    gpsPositionCount?: number;
    gsmQualityCount?: number;
    mortalityCount?: number;
    mortalityImplantCount?: number;
    proximityCount?: number;
    separationCount?: number;
    trapEventCount?: number;
    vaginalImplantCount?: number;
    virtualFenceCount?: number;
    collarLogCount?: number;
    lastPositionAcqTime?: string;
    lastPositionLatitude?: number;
    lastPositionLongitude?: number;
    lastPositionMainVoltage?: number;
    lastPositionBackupVoltage?: number;
    lastPositionMortalityStatus?: DeviceMetaInformationDto.LastPositionMortalityStatusEnum;
    secondLastPositionAcqTime?: string;
    secondLastPositionLatitude?: number;
    secondLastPositionLongitude?: number;
}
export namespace DeviceMetaInformationDto {
    export const LastReceptionEventTypeEnum = {
        Unknown: 'UNKNOWN',
        GpsPosition: 'GPS_POSITION',
        Separation: 'SEPARATION',
        TrapEvent: 'TRAP_EVENT',
        Proximity: 'PROXIMITY',
        Mortality: 'MORTALITY',
        MortalityImplant: 'MORTALITY_IMPLANT',
        VaginalImplant: 'VAGINAL_IMPLANT',
        Activity: 'ACTIVITY',
        GsmQuality: 'GSM_QUALITY',
        VirtualFence: 'VIRTUAL_FENCE',
        CollarLog: 'COLLAR_LOG'
    } as const;
    export type LastReceptionEventTypeEnum = typeof LastReceptionEventTypeEnum[keyof typeof LastReceptionEventTypeEnum];
    export const LastPositionMortalityStatusEnum = {
        NotAvailable: 'NOT_AVAILABLE',
        NothingDetected: 'NOTHING_DETECTED',
        LowActivityNoRadius: 'LOW_ACTIVITY_NO_RADIUS',
        LowActivityInsideRadius: 'LOW_ACTIVITY_INSIDE_RADIUS',
        LowActivityOutsideRadius: 'LOW_ACTIVITY_OUTSIDE_RADIUS',
        MortalityNoRadius: 'MORTALITY_NO_RADIUS',
        MortalityInsideRadius: 'MORTALITY_INSIDE_RADIUS',
        MortalityOutsideRadius: 'MORTALITY_OUTSIDE_RADIUS'
    } as const;
    export type LastPositionMortalityStatusEnum = typeof LastPositionMortalityStatusEnum[keyof typeof LastPositionMortalityStatusEnum];
}


export type LastReceptionEventTypeEnum = typeof DeviceMetaInformationDto.LastReceptionEventTypeEnum[keyof typeof DeviceMetaInformationDto.LastReceptionEventTypeEnum];
export type LastPositionMortalityStatusEnum = typeof DeviceMetaInformationDto.LastPositionMortalityStatusEnum[keyof typeof DeviceMetaInformationDto.LastPositionMortalityStatusEnum];
